import clsx from 'clsx';
import { types } from 'components/3cat/Formats';
import Mosaic from 'components/3cat/Mosaic';
import Boto from 'components/ui/Boto';
import __isEmpty from 'lodash/isEmpty';
import __map from 'lodash/map';
import __reduce from 'lodash/reduce';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styles from './az.module.scss';
import categories from './categories.json';

const _getItemsNoAgrupats = (items) => {
    return __reduce(
        items,
        (itemsAcumulats, itemsLletra) => {
            return itemsAcumulats.concat(itemsLletra.item);
        },
        []
    );
};
export default function Az(props) {
    let { items, programa, agrupar, routeType, slugRelacio, tagLletra, tagItem } = props;
    const TagLletra = tagLletra || `${'h2'}`;
    const router = useRouter();
    const categoria = router.query?.canal;
    const isPodcast = categoria === 'podcasts';
    const isSx3 = categoria === 'sx3';
    const isCampus = categoria === 'campus';
    const isSenseCategoria = __isEmpty(categoria);
    const format = router.query?.format === 'audio' ? 'audio' : 'video';
    const numItemsCarrega = 20;

    const [visibleItems, setVisibleItems] = useState([]);
    const [itemsNoAgrupats, setItemsNoAgrupats] = useState([]);
    const [numItemsVisibles, setNumItemsVisibles] = useState(0);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        setVisibleItems([]);
        const itemsNoAgrupats = agrupar ? _getItemsNoAgrupats(items) : items;
        setItemsNoAgrupats(itemsNoAgrupats);
        setNumItemsVisibles(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items]);

    useEffect(() => {
        if (!__isEmpty(itemsNoAgrupats)) loadMoreItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsNoAgrupats]);

    useEffect(() => {
        window.addEventListener('scroll', onHandleScroll);

        return () => {
            window.removeEventListener('scroll', onHandleScroll);
        };
    }, []);

    useEffect(() => {
        if (scrolled && items[visibleItems.length]) {
            loadMoreItems();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrolled]);

    const onHandleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop + 400 > document.scrollingElement.scrollHeight) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    const loadMoreItems = () => {
        const numItemsACarregar = numItemsVisibles + numItemsCarrega;
        setNumItemsVisibles(numItemsACarregar);
        const nousItems = itemsNoAgrupats.slice(numItemsVisibles, numItemsACarregar);

        let visibleItemsTmp = [...visibleItems];

        if (agrupar) {
            nousItems.map((item) => {
                if (visibleItemsTmp[visibleItemsTmp.length - 1]?.valor !== item.lletra)
                    visibleItemsTmp[visibleItemsTmp.length] = { valor: item.lletra, item: [] };

                visibleItemsTmp[visibleItemsTmp.length - 1]?.item.push(item);
            });
        } else {
            visibleItemsTmp = [...visibleItemsTmp, ...nousItems];
        }

        setVisibleItems(visibleItemsTmp);
    };

    const getCategories = () => {
        return categories.categories.map((e, i) => {
            const stylesCategoria = clsx({
                [styles.categoria]: true,
                [styles.selected]: e.tag_friendly === categoria
            });
            const estilBoto = e.tag_friendly !== categoria ? 'transparent' : '';
            const linkFormat = format === 'audio' && !['podcasts', 'pellicules'].includes(e.tag_friendly) ? '/audio' : '';
            const link = `/3cat/tot-cataleg/${e.tag_friendly}${linkFormat}`;

            return (
                <li key={`categoria-${e.tag_friendly}`}>
                    <Boto className={stylesCategoria} text={e.nom} estil={estilBoto} mida='s' link={link} />
                </li>
            );
        });
    };

    const getAudioVideoButtons = () => {
        if (isPodcast || !agrupar || isSx3 || isCampus || isSenseCategoria) return <></>;

        const link = `/3cat/tot-cataleg/${categoria}`;

        return (
            <div className={styles.iconesAudioVideo}>
                <Boto
                    estil='az'
                    icona='play_contorn_ple'
                    altIcona='icona play'
                    mida={28}
                    tag='icon'
                    link={link}
                    className={router.query?.format !== 'audio' && styles.selected}
                />
                <Boto
                    estil='az'
                    icona='auriculars_ple'
                    altIcona='icona auriculars'
                    mida={28}
                    tag='icon'
                    link={`${link}/audio`}
                    className={router.query?.format === 'audio' && styles.selected}
                />
            </div>
        );
    };

    const getFormatMosaic = () => {
        if (isPodcast || format === 'audio') return types.QUADRAT;

        return types.POSTER;
    };

    const _buildAz = (element, i) => {
        if (__isEmpty(element)) {
            return false;
        }

        const lletra = agrupar ? element.valor : 'videos';
        const link = lletra == '#' ? 'num' : lletra;
        const llista = agrupar ? element.item : element;
        const tipologia = programa ? 'WCR_PROGRAMA' : 'DTY_VIDEO_MM';

        return (
            <section key={i} className={styles.lletraWrapper} id={link}>
                {agrupar && <TagLletra className={styles.titolSeccio}>{lletra}</TagLletra>}
                <Mosaic
                    format={getFormatMosaic()}
                    items={llista}
                    numColumns='8'
                    classNameMosaic='az'
                    tipologia={tipologia}
                    showAfegeixALaLlista={false}
                    routeType={routeType}
                    slugRelacio={slugRelacio}
                    tagItem={tagItem}
                />
            </section>
        );
    };

    const _iterateItems = () => {
        return !__isEmpty(visibleItems) ? __map(visibleItems, (element, i) => _buildAz(element, i)) : null;
    };

    return (
        <>
            {!isSenseCategoria && (
                <div className={styles.catWrapper}>
                    <ul className={styles.categories}>{getCategories()}</ul>
                </div>
            )}

            <div>{getAudioVideoButtons()}</div>
            {agrupar && <div>{_iterateItems()}</div>}
            {(!programa || !agrupar) && <div>{_buildAz(visibleItems, 0)}</div>}
        </>
    );
}

Az.defaultProps = {
    lletra: 'a',
    categoria: 'series',
    programa: true,
    agrupar: true,
    routeType: '',
    slugRelacio: ''
};
